// extracted by mini-css-extract-plugin
export var gradientLeft = "PortfolioMarquee-module--gradientLeft--871b6";
export var gradientRight = "PortfolioMarquee-module--gradientRight--4abcc";
export var imageItem = "PortfolioMarquee-module--imageItem--73118";
export var marqueeContainer = "PortfolioMarquee-module--marqueeContainer--18fcc";
export var marqueeContent = "PortfolioMarquee-module--marqueeContent--fc845";
export var marqueeContentOffset = "PortfolioMarquee-module--marqueeContentOffset--f6b88";
export var marqueeRow = "PortfolioMarquee-module--marqueeRow--8535b";
export var marqueeTrack = "PortfolioMarquee-module--marqueeTrack--26793";
export var marqueeWrapper = "PortfolioMarquee-module--marqueeWrapper--9d605";
export var scroll = "PortfolioMarquee-module--scroll--39489";
export var scrollOffset = "PortfolioMarquee-module--scrollOffset--47ca7";